import React from 'react';
import Layout from '../../components/Layout';
import NotFound from '../../components/NotFound/NotFound';
import Guide from './Guide';
import GuidesIndex from './GuidesIndex';
import { GUIDE_PAGES } from './data';

// SEO B2.4: home-service cost guides / how-to blog. /guides = index, /guides/:slug = article.
async function action({ params, store }) {
  const siteTitle =
    (store.getState().siteSettings &&
      store.getState().siteSettings.data &&
      store.getState().siteSettings.data.siteTitle) ||
    'BestHand';

  const slug = params && params.slug;

  // Index page: /guides
  if (!slug) {
    return {
      title: `Home Resource Center — Maintenance Checklists & Cost Guides | ${siteTitle}`,
      description:
        'Seasonal home maintenance checklists, honest 2026 cost guides and hiring advice from the BestHand team — free, practical, written to prevent expensive repairs.',
      component: (
        <Layout>
          <GuidesIndex />
        </Layout>
      ),
    };
  }

  // Article page: /guides/:slug
  const data = GUIDE_PAGES[slug];
  if (!data) {
    return {
      title: `Page Not Found | ${siteTitle}`,
      status: 404,
      component: (
        <Layout>
          <NotFound title={'Page Not Found'} />
        </Layout>
      ),
    };
  }

  return {
    title: data.title,
    description: data.metaDescription,
    component: (
      <Layout>
        <Guide slug={slug} data={data} />
      </Layout>
    ),
  };
}

export default action;
